import { observer } from 'mobx-react-lite'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { TaxExtensionProgressionActionsContainer } from '@/features/jobs/details/components/JobProgressionCard/TaxExtensionProgressionActions/TaxExtensionProgressionActionsContainer'
import { AuthorizationSignedProgressionActions } from '@/features/jobs/details/components/JobProgressionCard/AuthorizationSignedProgressionActions'

export interface AuthorizationSignedProgressionActionsContainerProps {
  vm: JobProgressionViewModel
}

export const AuthorizationSignedProgressionActionsContainer = observer(
  function AuthorizationSignedProgressionActionsContainer({
    vm,
  }: AuthorizationSignedProgressionActionsContainerProps) {
    return (
      <AuthorizationSignedProgressionActions
        isAnyExtensionFlowAvailable={vm.isAnyExtensionFlowAvailable}
        onUploadFinalDocuments={vm.viewReturnFiledDocumentCreationModal}
        extensionActions={
          vm.isAnyExtensionFlowAvailable && (
            <TaxExtensionProgressionActionsContainer vm={vm} isSecondary />
          )
        }
      />
    )
  },
)
